<nz-tabset [nzTabBarExtraContent]="goToPM">
  @for (tab of activityTabsList; track tab;let i = $index) {
  <nz-tab nzTitle="{{ tab }}" (nzClick)="changeActivityTab(i)">
    <nz-table #sortTable [nzData]="activityTableData" nzTableLayout="fixed">
      <thead>
        <tr>
          @for (column of activityColumnsList; track column) {
          <th [nzSortFn]="column.compare" [nzSortPriority]="column.priority"
            [nzWidth]="'300px'">
            {{ column.title }}
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (data of sortTable.data; track data) {
        <tr>
          <td>
            <div class="taskColumnContainer">
              <span class="taskName">{{
                data.taskName || "No disponible"
              }}</span>
              <span>{{ data.taskDescription || "No disponible" }}</span>
            </div>
          </td>
          <td>
            <div class="assignedContainer">
              <div class="profileImage">
                <img
                  src="{{
                    data.assignedToImage !== ''
                      ? data.assignedToImage
                      : '../../../../assets/UserOutlined.svg'
                  }}"
                />
              </div>
              <div class="assignedInfo">
                <span class="assignedToName">{{
                  data.assignedToName || "No disponible"
                }}</span>
                <span>{{ data.assignedToRole || "No disponible" }}</span>
              </div>
            </div>
          </td>
          <td>
            <!-- <app-status-tag [currentStatus]="data.status"></app-status-tag> -->
          </td>
          <td>
            {{
              data.endDate
                ? (data.endDate | date : "dd/MM/yyyy")
                : "No disponible"
            }}
          </td>
        </tr>
        }
      </tbody>
    </nz-table>
  </nz-tab>
  }
</nz-tabset>
<ng-template #goToPM>
  <button nz-button>{{ extraActionButtonText }}</button>
</ng-template>
